//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "AllView01",
  components: {},
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      todayData: []
    };
  },
  computed: {},
  created: function created() {
    this.fetchToday();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchToday: function fetchToday() {
      var _this = this;

      this.loading = true;
      setTimeout(function () {
        _this.todayData = [{
          label: "浏览量（PV）",
          value: 194,
          level: "up"
        }, {
          label: "访客数（UV）",
          value: 34,
          level: "down"
        }, {
          label: "平均访问页数",
          value: 5,
          level: ""
        }];
        _this.loading = false;
      }, 500);
    }
  },
  watch: {},
  filters: {}
};